import React from 'react';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';
import 'react-modal-video/scss/modal-video.scss';
import { useLanguage } from '../../i18n';
import './style.scss';

const About = ({ videoId, className, signature, images, orderLast }) => {
    const [video, setVideo] = React.useState(false);
    const { t, language } = useLanguage();

    const aboutTextEn = [
        { text: "Founded by Aman Verma, Legal Corridor is a boutique multi-disciplinary firm engaged in providing professional legal services. A leading law firm in India, we handle an array of litigation in the Supreme Court of India, the High Court of Delhi, and the district courts in Delhi, Noida and Gurgaon." },
        { text: 'The firm has a diverse practice area focused on litigation in the areas of money recovery, commercial dispute between companies, family law, IPR Laws, RERA, property, succession and inheritance, consumer, civil and criminal litigation. It also advises on estate planning, and due diligence. <br /><br />' },
    ];

    const aboutTextHi = [
        { text: "अमन वर्मा द्वारा स्थापित, लीगल कॉरिडोर एक बुटीक बहु-विषयक फर्म है जो पेशेवर कानूनी सेवाएं प्रदान करने में लगी हुई है। भारत की एक प्रमुख कानूनी फर्म के रूप में, हम सुप्रीम कोर्ट ऑफ इंडिया, दिल्ली उच्च न्यायालय और दिल्ली, नोएडा और गुड़गांव की जिला अदालतों में विभिन्न मुकदमों को संभालते हैं।" },
        { text: '<br />फर्म के पास धन वसूली, कंपनियों के बीच वाणिज्यिक विवाद, पारिवारिक कानून, आईपीआर कानून, रेरा, संपत्ति, उत्तराधिकार और विरासत, उपभोक्ता, सिविल और आपराधिक मुकदमेबाजी के क्षेत्रों में विविध प्रैक्टिस क्षेत्र है। यह संपत्ति योजना और उचित परिश्रम पर भी सलाह देती है।<br /><br />' },
    ];

    const paragraphs = language === 'hi' ? aboutTextHi : aboutTextEn;

    return (
        <div className={className}>
            <div className="container">
                <div className="row">
                    <div className={orderLast ? `${orderLast} col col-lg-6` : 'col col-lg-6'}>
                        <div className="aboutImageWrap">
                            <img loading="lazy" decoding="async" src={images} alt="" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="aboutContent">
                            <span>{t('about.subtitle')}</span>
                            <h2>{t('about.title')}</h2>
                            {paragraphs.map((paragraph, index) => (
                                <div key={index} dangerouslySetInnerHTML={{ __html: paragraph.text.replace(/\n/g, '<br/>') }} />
                            ))}
                            <div className="btnStyle">
                                <Link to='/team'>{t('nav.team')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
